import {
  REMOVE_LESSON,
  REMOVE_LESSON_CLEAN,
  REMOVE_LESSON_SUCCESS,
  REMOVE_LESSON_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  lesson: undefined,
}

const LessonRemove = (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LESSON:
      state = {
        ...state,
        loading: true,
      }
      break
    case REMOVE_LESSON_SUCCESS:
      state = {
        ...state,
        loading: false,
        done: true,
        lesson: action.payload.lesson,
      }
      break
    case REMOVE_LESSON_CLEAN:
      state = initialState
      break
    case REMOVE_LESSON_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default LessonRemove
